// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Logo images are served by the API: GET /api/files/<account_id>
export const LOGO_BASE_URL = `${API_BASE_URL}/files`;

// Gallery images: GET /api/files/gallery/<account_id>/<photo_id>
export const GALLERY_BASE_URL = `${API_BASE_URL}/files/gallery`;

// Booking Types Constants
export const BOOKING_TYPES = {
  MEN: 'men',
  BOY: 'boy',
  FATHER_SON: 'father_son'
};

// Booking Type Names in Arabic
export const BOOKING_TYPE_NAMES = {
  'men': 'حلاقة شب',
  'boy': 'حلاقة ولد',
  'father_son': 'حلاقة أب وابن'
};

// Salon Contact Information
export const SALON_CONTACT = {
  phone: '+972526448758', // Update with actual phone number
  whatsapp: '+972526448758', // Update with actual WhatsApp number
  location: {
    address: 'شارع الرئيسي، رينة', // Update with actual address
    lat: 32.7222, // Update with actual latitude
    lng: 35.3167  // Update with actual longitude
  }
};

